import { HistoryEntryName } from '../User/HistoryEntryType';

// Declared in the order of the onboarding: the back-office lists them this way
export enum EMailType {
  WELCOME_LEEDFLOW = 'welcome_leedflow',
  ACCOUNT_ACTIVATED_LEEDFLOW = 'account_activated_leedflow',
  MEMBER_WELCOME_LEEDFLOW = 'member_welcome_leedflow',
  RESET_PASSWORD_LEEDFLOW = 'reset_password_leedflow',
  WELCOME_LEEDPULSE = 'welcome_leedpulse',
  RESET_PASSWORD_LEEDPULSE = 'reset_password_leedpulse',
}

export const mailTypeAsString = (emailType: EMailType): string => {
  switch (emailType) {
    case EMailType.WELCOME_LEEDFLOW:
      return '🟢 Leedflow > 01. Bienvenue (abonnement créé)';
    case EMailType.ACCOUNT_ACTIVATED_LEEDFLOW:
      return '🟢 Leedflow > 02. Identifiants du 1er utilisateur (onboarding)';
    case EMailType.MEMBER_WELCOME_LEEDFLOW:
      return '🟢 Leedflow > 03. Identifiants d\'un utilisateur ajouté';
    case EMailType.RESET_PASSWORD_LEEDFLOW:
      return '🟢 Leedflow > 99. Réinitialisation du mot de passe';
    case EMailType.WELCOME_LEEDPULSE:
      return '🟣 Leedpulse > 01. Bienvenue';
    case EMailType.RESET_PASSWORD_LEEDPULSE:
      return '🟣 Leedpulse > 99. Réinitialisation du mot de passe';
    default:
      return 'Type de mail non reconnu';
  }
};

// Returns the history entry name tracked for a mail type, or null when the mail is not tracked.
export const mailTypeToHistoryEntryName = (
  emailType: EMailType
): HistoryEntryName | null => {
  switch (emailType) {
    case EMailType.ACCOUNT_ACTIVATED_LEEDFLOW:
      return HistoryEntryName.email_account_activated_leedflow;
    case EMailType.WELCOME_LEEDFLOW:
      return HistoryEntryName.email_welcome_leedflow;
    case EMailType.MEMBER_WELCOME_LEEDFLOW:
      return HistoryEntryName.email_member_welcome_leedflow;
    default:
      return null;
  }
};
